module.exports = __webpack_public_path__ + "img/CC.d33718e9.png";